<template>
    <a href="/quantitative-fashion-institute" class="container">
        <l-video class="video" src="https://static.ycsd.work/site/b22.mp4"></l-video>
        
        <div class="img-text">
            <img src="https://static.ycsd.work/web/index4-text.png" alt="">
        </div>
    </a>
</template>

<script>
import LVideo from "../../../components/LVideo";

export default {
    name: "Banner3",
    components: {LVideo}
}
</script>

<style scoped>
.container {
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
}

.img-text {
    position: absolute;
}

.img-text img {
    width: 100%;
    height: 100%;
}

.video {
    min-width: 100%;
    min-height: 100%;
}


.t2 span {
    display: inline-block;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(249, 249, 249, 1);
}


</style>